import config from '@components/AdminPanelComponent/Users/config/api.config';

export const buildParams = (endpointType, params) => {
  const paramMapping = config.params[endpointType];
  
  if (!paramMapping) {
    console.warn(`[ParamBuilder] No parameter mapping found for endpoint: ${endpointType}`);
    return params;
  }

  const builtParams = {};
  
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      const mappedKey = paramMapping[key] || key;
      builtParams[mappedKey] = params[key];
    }
  });
  
  return builtParams;
};

export const getEndpointUrl = (endpointType, isMock) => {
  const useMock = isMock ?? (process.env.app_env === 'local' || process.env.app_env === 'dev');

  if (useMock) {
    return config.api.mockEndpoints[endpointType] || '';
  }

  const baseUrl = process.env.core_gateway_url || '';
  const path = config.api.endpoints[endpointType] || '';
  return `${path}`;
};